export default __webpack_public_path__ + "static/media/Stage3_rule.c182986b.png";